<nav class="navbar navbar-custom" role="navigation">
  <div class="dropdown">
    <span> <a (click)= "profileIconClick()"><img class="profile_image" src = "./assets/img/user.png"></a></span>
    <div class="dropdown-content">
      <!-- <a class="page-scroll" (click)= "register1Click()" style="cursor: pointer;" i18n>Register</a> -->
      <a class="page-scroll" (click)= "profileClick()" style="cursor: pointer;" i18n>Profile</a>
      <a *ngIf="is_country_fp" class="page-scroll" (click)= "manageTeamClick()" style="cursor: pointer;" i18n>Manage Team</a>
      <a class="page-scroll" (click)= "feedbackClick()" style="cursor: pointer;" i18n>Feedback</a>
      <a class="page-scroll" (click)= "logoutClick()" style="cursor: pointer;" i18n>Logout</a>
    </div>
  </div>
  <lang-change></lang-change>
  <div class="container-fluid">
    <div class="navbar-header">
      <button type="button" class="navbar-toggle navbar-togglecollapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
        Menu <i class="fa fa-bars"></i>
      </button>
    </div>
    <!-- Collect the nav links, forms, and other content for toggling -->
    <div id="navbar" class="collapse navbar-collapse collapsenavbar-collapse">
      <ul class="nav navbar-nav">
        <!-- Hidden li included to remove active class from introduction link when scrolled up past introduction section -->
        <li class="hidden">
          <a href="#page-top"></a>
        </li>
        <li class="nav-item-utility">
          <a class="page-scroll resource-click nav-utility-link" (click) = "resourceBtnClick()" style="cursor: pointer;">
            <svg class="nav-utility-svg nav-resource-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 7v14"></path><path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z"></path></svg>{{getNavTranslation('resource')}}
          </a>
        </li>
        <li>
          <a class="page-scroll integrity-click nav-component-link" (click) = "integrityBtnClick()" style="cursor: pointer;" i18n>Integrity</a>
        </li>
        <li>
          <a class="page-scroll resilience-click nav-component-link" (click) = "resilienceBtnClick()" style="cursor: pointer;" i18n>DRR/Resilience</a>
        </li>
        <li>
          <a class="page-scroll gender-click nav-component-link" (click) = "genderBtnClick()" style="cursor: pointer;" i18n>Gender</a>
        </li>
        <li>
          <a class="page-scroll policy-click nav-component-link" (click) = "policyBtnClick()" style="cursor: pointer;" i18n="@@Policy Header">Policy & Institutional</a>
        </li>
        <li>
          <a class="page-scroll finance-click nav-component-link" (click) = "financeBtnClick()" style="cursor: pointer;" i18n>Finance</a>
        </li>
        <li>
          <a class="page-scroll capacity-click nav-component-link" (click) = "capacityBtnClick()" style="cursor: pointer;" i18n>Capacity</a>
        </li>
        <li>
          <a class="page-scroll status-click nav-component-link nav-status-link" (click) = "statusBtnClick()" style="cursor: pointer;" i18n>Status</a>
        </li>
        <li class="nav-item-utility">
          <a class="page-scroll home-click nav-utility-link" (click) = "homeBtnClick()" style="cursor: pointer;">
            <i class="fa fa-home nav-utility-icon" aria-hidden="true"></i><span i18n>Home</span>
          </a>
        </li>
      </ul>
    </div>
    <!-- /.navbar-collapse -->
  </div>
  <!-- /.container -->
</nav>



// WEBPACK FOOTER //
// ./src/app/sdg/sdg-header/sdg-header.component.html